var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-card',{staticClass:"box-card"},[_c('channel-data-trend-pic'),_c('channel-data-detail')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }